export const PCPAGE_LINKS = {
  home: '/',
  adminLogin: '/admin/login',
  admin: '/admin',
  cancelVip: '/admin/cancel_vip',
  saleSlug: '/admin/sale_slug',
}


export const MOBILE_PAGE_LINKS = {
  mobileHome: '/mobile',
  search: '/mobile/search',
  goodsDetail: '/mobile/template',
  buyRecommend: '/mobile/buyRecommend',
  wxPay: '/wx_pay',
  wxLogin: '/wx_login',
}

export type PAGE_LINKS_TYPE = typeof PCPAGE_LINKS & typeof MOBILE_PAGE_LINKS

export const PAGE_LINKS = {
  ...PCPAGE_LINKS,
  ...MOBILE_PAGE_LINKS,
} as PAGE_LINKS_TYPE

export const enum UserActionEnum {
  CLICK = '点击',
  SHOW = '展示',
  SEARCH = '搜索',
}

export const enum UserActionElementEnum {
  PAGE = '页面',
  BUTTON = '按钮',
  MODAL = '弹窗',
  SEARCH = '搜索框',
}

export const enum UserActionModuleEnum {
  PC = '快动画PC端',
  MOBILE = '快动画移动端',
}
